export const locationRegistry = {
  vinterbro: {
    api: {
      primary: "https://vinterbro.wioss.no/api",
      fallback: "https://cloud.wioss.no/api",
      customer: "https://wimulerdo.rema.no/api",
      healthPath: "/health",
    },
    customerOrigin: {
      domain: "wimulerdo.rema.no",
      apiBaseUrl: "https://wimulerdo.rema.no/api", // or same as primary, if it's just a redirect target
      allowCloudFallback: false, // customer not on WIOSS cloud.
    },
    ui: {
      theme: "vinterbro",
      pageVersion: "v2",
    },
    features: {
      shiftPlan: true,
      employees: true,
      lunchMenu: true,
      maintenance: true,
      depal: true,
      yggdrasil: true,
    },
    security: {
      requiresAuthentication: false,
      requiresSentryToken: ["employees", "users", "settings"],
    },
  },
  vagle: {
    api: {
      primary: "https://vagle.wioss.no/api",
      fallback: null,
      healthPath: "/health",
    },
    ui: { theme: "vagle", pageVersion: "v1" },
    features: {
      shiftPlan: false,
      employees: false,
      lunchMenu: true,
      maintenance: false,
      depal: false,
      yggdrasil: false,
    },
    security: {
      requiresAuthentication: false,
      requiresSentryToken: ["employees", "users", "settings"],
    },
  },
  cloud: {
    api: {
      primary: "https://cloud.wioss.no/api",
      fallback: null,
      healthPath: null,
    },
    ui: { theme: "default", startmenu: ["/lunchmenu"], pageVersion: "v1" },
    features: {
      dashboard: false,
      shiftPlan: false,
      employees: false,
      lunchMenu: true,
      maintenance: false,
      machineFaults: false,
      depal: false,
      yggdrasil: true,
    },
    security: {
      requiresAuthentication: true,
      requiresSentryToken: ["employees", "users", "settings"],
    },
  },
  Default: {
    api: {
      primary: "https://cloud.wioss.no/api",
      fallback: null,
      healthPath: null,
    },
    ui: { theme: "default", startmenu: ["/dashboard"], pageVersion: "v1" },
    features: {
      shiftPlan: false,
      employees: false,
      lunchMenu: true,
      maintenance: true,
      depal: false,
      yggdrasil: true,
      activeFaults: true,
    },
    security: {
      requiresAuthentication: true,
      requiresSentryToken: ["employees", "users", "settings"],
    },
  },
};

export const currentLocationConfig =
  locationRegistry[import.meta.env.VITE_LOCATION] ?? locationRegistry.Default;

export function getStartRoute() {
  const location =
    import.meta.env.VITE_LOCATION?.toLowerCase();

  const config =
    locationRegistry[location] ??
    locationRegistry.Default;

    console.log(
"Location Key",
import.meta.env.VITE_LOCATION
);

  console.log(
    "Start Route Config",
    location,
    config
  );

  const startMenu =
    config.ui?.startmenu ??
    ["/dashboard"];

  return startMenu[0];
}
